
import Vue from 'vue';
import { Icon } from '@descomplica/vue-components';

export enum AllowedTypes {
  DANGER = 'danger',
  WARNING = 'warning',
  CERTIFICATE = 'certificate',
}

export default Vue.extend({
  components: {
    Icon,
  },
  props: {
    hasCloseButton: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String as Vue.PropType<AllowedTypes>,
      default: AllowedTypes.WARNING,
    },
  },
  data() {
    return {
      allowedCalloutTypes: AllowedTypes,
    };
  },
  methods: {
    onCloseClick() {
      this.$emit('onCloseClick');
    },
  },
});
